import React from 'react';
import {
  Calendar, AlertTriangle, Bell, Clock, CheckCircle, DollarSign
} from 'lucide-react';
import './DispatchStatStrip.css';

function DispatchStatStrip({
  stats,
  needsSchedulingCount,
  statusFilter,
  onStatusFilterChange,
  onScrollToAttention,
}) {
  const toggle = (key) => {
    if (statusFilter === key) onStatusFilterChange(null);
    else onStatusFilterChange(key);
  };

  return (
    <div className="dispatch-stat-strip" role="toolbar" aria-label="Dispatch stats">
      <div className="stat-chip stat-total" title="All jobs today">
        <Calendar size={14} />
        <span className="stat-chip-value">{stats.total}</span>
        <span className="stat-chip-label">Jobs</span>
      </div>

      {stats.unassigned > 0 && (
        <button
          type="button"
          className={`stat-chip stat-warning ${statusFilter === 'unassigned' ? 'active' : ''}`}
          onClick={() => toggle('unassigned')}
          title="Click to filter unassigned jobs"
        >
          <AlertTriangle size={14} />
          <span className="stat-chip-value">{stats.unassigned}</span>
          <span className="stat-chip-label">Unassigned</span>
        </button>
      )}

      {needsSchedulingCount > 0 && (
        <button
          type="button"
          className="stat-chip stat-danger"
          onClick={onScrollToAttention}
          title="Jump to clients needing scheduling"
        >
          <Bell size={14} />
          <span className="stat-chip-value">{needsSchedulingCount}</span>
          <span className="stat-chip-label">Needs Scheduling</span>
        </button>
      )}

      <button
        type="button"
        className={`stat-chip stat-info ${statusFilter === 'in_progress' ? 'active' : ''}`}
        onClick={() => toggle('in_progress')}
        title="Click to filter in-progress jobs"
      >
        <Clock size={14} />
        <span className="stat-chip-value">{stats.inProgress}</span>
        <span className="stat-chip-label">In Progress</span>
      </button>

      <button
        type="button"
        className={`stat-chip stat-success ${statusFilter === 'completed' ? 'active' : ''}`}
        onClick={() => toggle('completed')}
        title="Click to filter completed jobs"
      >
        <CheckCircle size={14} />
        <span className="stat-chip-value">{stats.completed}</span>
        <span className="stat-chip-label">Completed</span>
      </button>

      <div className="stat-chip stat-revenue" title="Today's revenue">
        <DollarSign size={14} />
        <span className="stat-chip-value">${stats.revenue.toLocaleString()}</span>
        <span className="stat-chip-label">Revenue</span>
      </div>
    </div>
  );
}

export default DispatchStatStrip;
